<section [dir]="appTranslate.isRTL() ? 'rtl' : 'ltr'">
  <div class="dialog-header">
    <app-general-icon-button
      buttonStyle="inline"
      buttonIcon="close-thin"
      (buttonClicked)="dialogRef.close(false)"
    />
  </div>
  <div class="dialog-content">
    <div class="confirm-title" [innerHTML]="data.title | translate"></div>
    <div class="confirm-description" [innerHTML]="data.description | translate"></div>
  </div>
  <div class="dialog-footer">
    <app-general-button
      [buttonStyle]="'primary'"
      [buttonAccentStyle]="data.type"
      [buttonHeight]="32"
      [buttonName]="data.confirmBtnName"
      (buttonClicked)="dialogRef.close(true)"
    />
    <app-general-button
      [buttonStyle]="'secondary'"
      [buttonAccentStyle]="data.type"
      [buttonHeight]="32"
      [buttonName]="data.cancelBtnName"
      (buttonClicked)="dialogRef.close(false)"
    />
  </div>
</section>
